<template>
    <div class="pay">
        <!-- <div class="pricedetail">
            <div class="price">¥360</div>
            <div class="desc">
                2年套餐分24期 每期¥25.00
            </div>
        </div>
        <div class="btn" @click="confirmPay">确认支付</div> -->
        <!-- <div v-html="content" style="height: 100vh"></div> -->
    </div>
</template>

<script>
import { clientPaymentPay } from '@/api/h5';
export default {
    name: 'h5pay',
    data() {
        return {
            content: ''
        }
    },
    created() {
        // console.log(this.$route.query)
    },
    async mounted() {
        this.confirmPay();
    },
    methods: { 
        async confirmPay() {
            let params = {
                orderId: this.$route.query.orderId,
                payType: this.$route.query.payType,
                isSign: false
            }
            let res = await clientPaymentPay(params,this.$route.query.token)
            const div=document.createElement('divform');
            div.innerHTML=res.content.orderInfo;
            document.body.appendChild(div);
            document.forms[0].acceptCharset='UTF-8';//保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
            document.forms[0].submit();
            // window.location.href = res.content.orderInfo
        }
    }
}
</script>

<style lang="scss" scoped>

.pay {
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
    height: 100vh;
    padding-top: 1rem;
    .pricedetail {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        .price {
            font-size: .48rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            margin-bottom: .28rem;
        }
        .desc {
            font-size: .28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
    }
    .btn {
        margin: 0 auto;
        margin-top: auto;
        margin-bottom: 1rem;
        width: 7.1rem;
        height: 1rem;
        background: #2AD0B5;
        border-radius: .2rem;
        font-size: .34rem;
        font-family: PingFangSC-Regular, PingFang SC;
        text-align: center;
        line-height: 1rem;
        font-weight: 400;
        color: #FFFFFF;
    }
    // form {
    //     height: 100%;
    // }
}
</style>